var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 1.0096C9.26676 1.00337 9.13339 1.00017 9 1C4.5824 1 1 4.4272 1 8.6536C1 10.684 1.8264 12.5296 3.1752 13.8984C3.472 14.2 3.6704 14.612 3.5904 15.036C3.46017 15.7244 3.1614 16.3697 2.7208 16.9144C3.87424 17.1252 5.06507 16.94 6.1 16.3888C6.4632 16.196 6.6448 16.0992 6.7736 16.08C6.9024 16.0608 7.0856 16.0944 7.452 16.1632C7.9624 16.2592 8.4808 16.3072 9 16.3072C13.4176 16.3072 17 12.88 17 8.6536C17 8.50107 16.9955 8.34987 16.9864 8.2M11.4 3.8H17M14.2 1V6.6M8.9968 9H9.0032M12.1928 9H12.2M5.8 9H5.8072",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionPlus);
export default __webpack_public_path__ + "static/media/question-plus.08d25726.svg";
export { ForwardRef as ReactComponent };